import { Skeleton } from '@/components/ui'
import { DetalhesLeadRepresadoContentSkeleton } from '@/pages/detalhes-lead-represado/ui/detalhes-lead-represado-content'

export const DetalhesLeadRepresadoPageSkeleton = () => {
  return (
    <div className="mx-auto min-h-screen w-full sm:max-w-4xl" data-testid="detalhes-lead-represado-skeleton">
      <div className="mb-8">
        <Skeleton className="mb-2 h-7 w-64" />
        <Skeleton className="h-4 w-96" />
      </div>
      <div className="border-muted border-1 bg-white px-4 py-6">
        <DetalhesLeadRepresadoContentSkeleton />
      </div>
    </div>
  )
}
